// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import BannerSortController from "./banner_sort_controller"
application.register("banner-sort", BannerSortController)

import FaqSortController from "./faq_sort_controller"
application.register("faq-sort", FaqSortController)
